var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "db" }, [
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "sydw" }, [
          _c("img", { attrs: { src: require("../assets/images/sydw.png") } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dbwz" }, [
          _c("div", [_vm._v("互联网信息服务备案号：粤ICP 备05013162 号")]),
          _vm._v(" "),
          _c("div", [_vm._v("本网站由广东水科院网络中心设计、维护")]),
          _vm._v(" "),
          _c("div", [_vm._v("地址：广州市天河区天寿路116号、广东水利大厦B座")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "aw" }, [
          _c("img", { attrs: { src: require("../assets/images/aw.png") } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "zat" }, [
          _c("img", { attrs: { src: require("../assets/images/zat.png") } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "skygzh" }, [
          _c("img", { attrs: { src: require("../assets/images/sky.png") } })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10e356bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e356bb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom.vue
// module id = 288
// module chunks = 34